import SideIconEarn from '@pancakeswap/uikit/components/Svg/Icons/SideIconEarn'
import SideIconExplore from '@pancakeswap/uikit/components/Svg/Icons/SideIconExplore'
import SideIconGold from '@pancakeswap/uikit/components/Svg/Icons/SideIconGold'
import SideIconHome from '@pancakeswap/uikit/components/Svg/Icons/SideIconHome'
import SideIconRewards from '@pancakeswap/uikit/components/Svg/Icons/SideIconRewards'
import SideIconStaking from '@pancakeswap/uikit/components/Svg/Icons/SideIconStaking'
import SideIconSwap from '@pancakeswap/uikit/components/Svg/Icons/SideIconSwap'
import SideIconTrade from '@pancakeswap/uikit/components/Svg/Icons/SideIconTrade'

export const menuConfig = [
  {
    id: 'home',
    label: 'Home',
    icon: SideIconHome,
    path: '/home',
  },
  {
    id: 'trade',
    label: 'Trade',
    icon: SideIconTrade,
    path: '/swap',
    children: [
      { id: 'swap', label: 'Swap', icon: SideIconSwap, path: '/swap' },
      { id: 'explore', label: 'Explore', icon: SideIconExplore, path: '/explore' },
    ],
  },
  {
    id: 'earn',
    label: 'Earn',
    icon: SideIconEarn,
    path: '/gold',
    children: [
      { id: 'yield', label: '$GOLD Yield', icon: SideIconGold, path: '/gold' },
      { id: 'staking', label: 'Alchemy Staking', icon: SideIconStaking, path: '/stake' },
    ],
  },
  {
    id: 'rewards',
    label: 'Rewards',
    icon: SideIconRewards,
    path: '/rewards',
  },
]
